import { notify } from 'utils/reduxUtils';

export const types = {
  AVAILABILITY_CHECK_FINISH:
    'modules/common/forms/materialWidget/AVAILABILITY_CHECK_FINISH',
  AVAILABILITY_CHECK_START:
    'modules/common/forms/materialWidget/AVAILABILITY_CHECK_START',
  INTERROGATION_REQUEST:
    'modules/common/forms/materialWidget/INTERROGATION_REQUEST',
  MATERIAL_WIDGET_INIT_ERROR:
    'modules/common/forms/materialWidget/MATERIAL_WIDGET_INIT_ERROR',
  MATERIAL_WIDGET_INIT_REQUEST:
    'modules/common/forms/materialWidget/MATERIAL_WIDGET_INIT_REQUEST',
  MATERIAL_WIDGET_INIT_SUCCESS:
    'modules/common/forms/materialWidget/MATERIAL_WIDGET_INIT_SUCCESS',
  MATERIAL_WIDGET_LEAVE:
    'modules/common/forms/materialWidget/MATERIAL_WIDGET_LEAVE',
  MATERIAL_WIDGET_RECEIVE_PART_FILE_PACKET:
    'modules/common/forms/materialWidget/MATERIAL_WIDGET_RECEIVE_PART_FILE_PACKET',
  MATERIAL_WIDGET_RECEIVE_SELECTED_MATERIAL_ID:
    'modules/common/forms/materialWidget/MATERIAL_WIDGET_RECEIVE_SELECTED_MATERIAL_ID',
  MATERIAL_WIDGET_RESET:
    'modules/common/forms/materialWidget/MATERIAL_WIDGET_RESET',
  MATERIAL_WIDGET_RESET_CHILDREN:
    'modules/common/forms/materialWidget/MATERIAL_WIDGET_RESET_CHILDREN',
  MATERIAL_WIDGET_SET_PROVIDER:
    'modules/common/forms/materialWidget/MATERIAL_WIDGET_SET_PROVIDER',
  MATERIAL_WIDGET_TURN_OFF_VISUALIZATION_IF_NECESSARY:
    'modules/common/forms/materialWidget/MATERIAL_WIDGET_TURN_OFF_VISUALIZATION_IF_NECESSARY',
  RECEIVE_NEW_VISUALIZE_SUCCESS_KEY:
    'modules/common/forms/materialWidget/RECEIVE_NEW_VISUALIZE_SUCCESS_KEY',
  RECEIVE_PREVIOUS_CADVIEWER_KEYS:
    'modules/common/forms/materialWidget/RECEIVE_PREVIOUS_CADVIEWER_KEYS',
  RECEIVE_STATUSES: 'modules/common/forms/materialWidget/RECEIVE_STATUSES',
  RECEIVE_VISUALIZED_KEY:
    'modules/common/forms/materialWidget/RECEIVE_VISUALIZED_RESULT_KEY',
  RECORD_NAVIGATE_TO_VENDOR_EVENT:
    'modules/common/forms/materialWidget/RECORD_NAVIGATE_TO_VENDOR_EVENT',
  SET_ACTIVE_TAB: 'modules/common/forms/materialWidget/SET_ACTIVE_TAB',
  STOCK_INTERROGATING_LIST_ADD:
    'modules/common/forms/materialWidget/STOCK_INTERROGATING_LIST_ADD',
  STOCK_INTERROGATING_LIST_REMOVE:
    'modules/common/forms/materialWidget/STOCK_INTERROGATING_LIST_REMOVE',
  VISUALIZE_HIDE_REQUEST:
    'modules/common/forms/materialWidget/VISUALIZE_HIDE_REQUEST',
  VISUALIZE_SHOW_ERROR:
    'modules/common/forms/materialWidget/VISUALIZE_SHOW_ERROR',
  VISUALIZE_SHOW_REQUEST:
    'modules/common/forms/materialWidget/VISUALIZE_SHOW_REQUEST',
  VISUALIZE_SHOW_SUCCESS:
    'modules/common/forms/materialWidget/VISUALIZE_SHOW_SUCCESS',
};

export const materialWidget = {
  checkAvailabilityFinish: ({ materialAvailability }) => ({
    type: types.AVAILABILITY_CHECK_FINISH,
    payload: { materialAvailability },
  }),
  checkAvailabilityStart: () => ({
    type: types.AVAILABILITY_CHECK_START,
  }),
  initError: notify(
    (error) => ({
      type: types.MATERIAL_WIDGET_INIT_ERROR,
      payload: error,
    }),
    'Failed to initialize material widget',
  ),
  initRequest: ({ materialId, partFileUuid, partUuid, provider }) => ({
    type: types.MATERIAL_WIDGET_INIT_REQUEST,
    payload: { materialId, partFileUuid, partUuid, provider },
  }),
  initSuccess: () => ({
    type: types.MATERIAL_WIDGET_INIT_SUCCESS,
  }),
  interrogationRequest: ({ stockTask, customInterrogationId }) => ({
    type: types.INTERROGATION_REQUEST,
    payload: { stockTask, customInterrogationId },
  }),
  leave: () => ({
    type: types.MATERIAL_WIDGET_LEAVE,
  }),
  receivePartFilePacket: ({ partFilePacket }) => ({
    type: types.MATERIAL_WIDGET_RECEIVE_PART_FILE_PACKET,
    payload: { partFilePacket },
  }),
  receivePreviousCADViewerKeys: ({ previousCADViewerKeys }) => ({
    type: types.RECEIVE_PREVIOUS_CADVIEWER_KEYS,
    payload: { previousCADViewerKeys },
  }),
  receiveSelectedMaterialId: ({ materialId }) => ({
    type: types.MATERIAL_WIDGET_RECEIVE_SELECTED_MATERIAL_ID,
    payload: { materialId },
  }),
  receiveStatuses: ({ partFileStatuses }) => ({
    type: types.RECEIVE_STATUSES,
    payload: { partFileStatuses },
  }),
  reset: () => ({
    type: types.MATERIAL_WIDGET_RESET,
  }),
  resetChildren: () => ({
    type: types.MATERIAL_WIDGET_RESET_CHILDREN,
  }),
  setProvider: ({ provider }) => ({
    type: types.MATERIAL_WIDGET_SET_PROVIDER,
    payload: { provider },
  }),
  turnOffVisualizationIfNecessary: () => ({
    type: types.MATERIAL_WIDGET_TURN_OFF_VISUALIZATION_IF_NECESSARY,
  }),
};

export const stockInterrogatingList = {
  add: ({ uuid }) => ({
    type: types.STOCK_INTERROGATING_LIST_ADD,
    payload: { uuid },
  }),
  remove: ({ uuid }) => ({
    type: types.STOCK_INTERROGATING_LIST_REMOVE,
    payload: { uuid },
  }),
};

export const visualize = {
  hideRequest: () => ({
    type: types.VISUALIZE_HIDE_REQUEST,
  }),
  receiveNewSuccesfullyVisualizedKey: ({ resultKey }) => ({
    type: types.RECEIVE_NEW_VISUALIZE_SUCCESS_KEY,
    payload: { resultKey },
  }),
  receiveVisualizedKey: ({ resultKey }) => ({
    type: types.RECEIVE_VISUALIZED_KEY,
    payload: { resultKey },
  }),
  showError: notify(
    (error) => ({
      type: types.VISUALIZE_SHOW_ERROR,
      payload: error,
    }),
    'Stock Visualization Error',
  ),
  showRequest: ({ result }) => ({
    type: types.VISUALIZE_SHOW_REQUEST,
    payload: { result },
  }),
  showSuccess: () => ({
    type: types.VISUALIZE_SHOW_SUCCESS,
  }),
};

export const recordEvent = {
  recordNavigateToVendor: ({ stockType, vendorName }) => ({
    type: types.RECORD_NAVIGATE_TO_VENDOR_EVENT,
    payload: { stockType, vendorName },
  }),
};
